import { COLOR_PALETTE } from 'app/constants/ColorPalette';

export const PURE_WHITE = '#fff';
export const PURE_BLACK = '#000';
export const PURE_RED = '#f00';
export const GREY_A = '#2d2d2b';
export const GREY_B = '#404040';
export const GREY_C = '#aaa';
export const GREY_D = '#999';
export const GREY_E = '#323232';
export const GREY_F = '#d7d7d7';
export const GREY_G = '#727272';
export const GREY_H = '#e0e0e0';
export const GREY_I = '#b8b8b8';
export const GREY_J = '#ccc';
export const GREY_L = '#ebecf0';
export const GREY_N = '#e5e5e5';
export const GREY_P = '#6d6d6d';
export const GREY_Q = '#888';
export const GREY_R = '#c0c0c0';
export const GREY_S = '#787878';
export const GREY_T = '#1f1f1f';
export const GREY_U = '#ebebeb';
export const GREY_V = '#f9f9f9';
export const TRANSPARENT_GREY_A = 'rgba(64, 64, 64, 0.5)';
export const TAG_SHADOW = 'rgba(26, 26, 26, 0.22)';
export const WHITE_A = '#f2f2f2';
export const WHITE_B = '#f8f8f8';
export const WHITE_C = 'rgba(242, 242, 242, 0.2)';
export const ORANGE_A = '#ff8b00';
export const ORANGE_B = '#e45d36';
export const ORANGE_C = '#ff7300';
export const BLUE_A = '#2BACEE';
export const BLUE_B = '#edf8ff';
export const BLUE_C = '#1babff';
export const BLUE_E = '#cae4f5';
export const BLUE_F = '#009dff';
export const BLUE_G = '#0096fb';
export const BLUE_H = '#3b9cff';
export const TRANSPARENT_BLUE_H = 'rgba(59,156,255, 0)';
export const BLUE_I = '#0085df';
export const BLUE_J = '#e2f4ff';
export const DARK_BLUE_A = '#4967ad';
export const DARK_BLUE_B = '#3f5996';
export const LIGHT_BLUE_A = '#eff6fe';
export const GREEN_A = '#e9f9f3';
export const GREEN_B = '#216d24';
export const GREEN_E = '#c1eedd';
export const GREEN_F = '#7edcb9';
export const GREEN_G = '#c1dfcf';
export const GREEN_H = '#a9d948';
export const GREEN_I = '#eef7dc';
export const RED_A = '#fff0ee';
export const RED_B = '#ff310e';
export const RED_C = '#ffc3bb';
export const RED_D = '#ff7866';
export const RED_E = '#ffe2dc';
export const RED_F = '#f6d1cd';
export const RED_G = '#f64c58';
export const RED_H = '#ff3652';
export const TRANSPARENT_RED_H = 'rgba(255, 54, 82, 0)';
export const RED_I = '#e02e44';
export const RED_J = '#fee9ea';
export const YELLOW_A = '#fff3ab';
export const YELLOW_B = '#ffe539';

// Primary Colors
export const BLUE = BLUE_F;

// Used as placeholder colors for loading data.
export const PLACEHOLDER_A = '#eadbcd';
export const PLACEHOLDER_B = '#e2e8df';
export const PLACEHOLDER_C = '#ebf0f7';
export const PLACEHOLDER_D = '#dde0e5';
export const PLACEHOLDER_E = '#f3ebd0';
export const PLACEHOLDER_F = '#ede7ed';
export const PLACEHOLDER_G = '#e5e1de';

// It is not necessary to add aliases for *every* color here, you can now just use the above
// abitrarily-named constants in component files directly.
export const PAGE_BACKGROUND_COLOR = WHITE_A;

export const ICON_DEFAULT_HIGHLIGHT_COLOR = WHITE_A;
export const TAG_DEFAULT_COLOR = GREY_A;

export const NAVIGATION_BACKGROUND_COLOR = COLOR_PALETTE.grey.white;
export const NAVIGATION_TEXT_COLOR = COLOR_PALETTE.grey.darker;
export const NAVIGATION_TEXT_HIGHLIGHT_COLOR = COLOR_PALETTE.grey.darker;
export const NAVIGATION_BACKGROUND_HIGHLIGHT_COLOR = COLOR_PALETTE.grey.lighter;

export const DAILY_NEWS_TITLE_COLOR = GREY_A;
export const DAILY_NEWS_BORDER_COLOR = WHITE_B;

export const LESSON_CARD_TEXT_COLOR = GREY_D;
export const LESSON_CARD_TITLE_COLOR = GREY_E;
export const LESSON_CARD_TITLE_HIGHLIGHT_COLOR = GREY_D;

export const LESSON_IMAGE_DEFAULT_PLACEHOLDER_COLOR = WHITE_B;

export const LESSON_BORDER_COLOR = WHITE_A;
export const LESSON_BORDER_HIGHLIGHT_COLOR = GREY_N;

export const LESSON_VOCAB_PRONUNCIATION_COLOR = GREY_G;
export const LESSON_VOCAB_POS_TEXT_COLOR = GREY_B;
export const LESSON_VOCAB_WORD_COLOR = ORANGE_A;
export const LESSON_VOCAB_COMPACT_HOVER = WHITE_B;
export const LESSON_SOUND_LINK_COLOR = GREY_I;
export const LESSON_SOUND_BUTTON_COLOR = PURE_BLACK;
export const LESSON_SOUND_LINK_LOADING_COLOR = GREY_J;
export const LESSON_SOUND_BUTTON_LOADING_COLOR = GREY_E;
export const LESSON_SOUND_LINK_HIGHLIGHT_COLOR = ORANGE_A;
export const LESSON_SENTENCE_BACKGROUND_COLOR = WHITE_B;
export const LESSON_SENTENCE_EXPAND_BUTTON_TEXT_COLOR = GREY_B;
export const LESSON_SENTENCE_EXPAND_BUTTON_BACKGROUND_COLOR = WHITE_A;

// Alerts
export const DANGER_BACKGROUND_COLOR = RED_J;

export const INFO_BACKGROUND_COLOR = BLUE_J;

export const SUCCESS_BACKGROUND_COLOR = GREEN_I;

export const DANGER_TITLE_COLOR = RED_B;
export const INFO_TITLE_COLOR = BLUE_C;
export const SUCCESS_TITLE_COLOR = GREEN_B;

export const ALERT_TEXT_COLOR = GREY_B;

// MultiSelect menus.
export const MULTI_SELECT_POSITIVE = GREEN_E;
export const MULTI_SELECT_POSITIVE_HIGHLIGHT = GREEN_F;
export const MULTI_SELECT_NEGATIVE = RED_C;
export const MULTI_SELECT_NEGATIVE_HIGHLIGHT = RED_D;

// Links
export const LINK_COLOR = BLUE_F;
export const LINK_HOVER_COLOR = BLUE_I;
export const DISABLED_LINK_COLOR = GREY_C;
